<template>
    <v-modal title="Email Invoice" @close="$emit('close')" size="large" scroll>
        <div slot="content">
            <div class="grid-content">
                <div class="grid-item grid-item-full" v-if="$v.$invalid">
                    <v-error-messages>
                        <li class="list-item" v-if="!$v.email.subject.required">Please provide a subject for the email.</li>
                    </v-error-messages>
                </div>
                <div class="grid-item grid-item-full">
                    <r-input
                        label="To"
                        :disabled="true"
                        v-model="email.to[0]"/>
                </div>
                <div class="grid-item grid-item-full">
                    <r-input
                        label="Subject"
                        :validate="$v.email.subject"
                        v-model="email.subject"/>
                </div>
                <div class="grid-item grid-item-full">
                    <label class="field-label">Email Body</label>
                    <v-iframe-sandbox :html="email.html" class="invoice-body"/>
                </div>
                <div class="grid-item grid-item-full">
                    <r-checkbox
                        :label="`Attach Invoice #${invoice.invoiceNumber}`"
                        :value="true"
                        v-model="includeInvoice"/>
                </div>
            </div>
        </div>
        <template slot="actions">
            <r-button
                type="primary"
                :disabled="$v.$invalid && isSending"
                @click="send">Send</r-button>
        </template>
    </v-modal>
</template>

<script>
    import vModal from '@/components/modal/v-modal';
    import vIframeSandbox from '@/components/v-iframe-sandbox';
    import {
        vErrorMessages,
    } from '@/components/form';
    import {required} from 'vuelidate/lib/validators';

    export default {
        name: 'invoice-email-modal',
        components: {
            vModal,
            vIframeSandbox,
            vErrorMessages,
        },
        props: {
            customer: {
                type: Object,
            },
            invoice: {
                type: Object,
            },
            email: {
                type: Object,
            },
        },
        data() {
            return {
                includeInvoice: true,
                isSending: false,
            };
        },
        validations: {
            email: {
                subject: {
                    required,
                },

            },
        },
        methods: {
            send() {
                if (!this.$v.$error) {
                    this.isSending = true;
                    if (this.includeInvoice) {
                        this.email.addAttachments([{
                            resourceType: 'invoice',
                            resourceId: this.invoice.id,
                        }]);
                    }
                    this.$emit('input', this.email);
                    this.$emit('close');
                    this.isSending = false;
                }
            },
        },
    };
</script>
